<template>
  <div>
    <div class="commands">
      <span class="filter" id="CO2">CO2</span>
      <span class="filter" id="NO2">NO2</span>
    </div>
    <div id="chart1"></div>
  </div>
</template>

<script>
import * as d3 from "d3";
// import * as path from "path";

import { barchart2 } from "@/lib/barchart2";

export default {
  name: "barchart2",
  data: function() {
    return {
      chartData: null
    };
  },
  methods: {
    barchart2
  },
  mounted: function() {
    // console.log("mounted!!");
    this.barchart2();
  }
};
</script>

<style scoped>
>>> .axis path,
>>> .axis line {
  fill: none;
  stroke: black;
  shape-rendering: crispEdges;
}

>>> .axis text {
  font-family: Courier;
  font-size: 0.85em;
}

>>> text {
  font-family: Courier;
  font-size: 0.65em;
}

>>> div.commands {
  font-family: Courier;
  font-size: 0.85em;
  font-weight: bold;
  text-align: center;
  cursor: default;
  user-select: none;
}

>>> svg {
  display: block;
  margin: auto;
  background-color: #fafafa;
}

>>> .bar {
  fill: #add8e677;
}

>>> text.xlabel {
  text-anchor: middle;
}

text.ylabel {
  text-anchor: middle;
  alignment-baseline: central;
}

>>> text.name {
  font-weight: bold;
  text-anchor: middle;
  alignment-baseline: central;
}

>>> .sort {
  border-radius: 3px;
  background-color: #eee;
  display: inline-block;
  cursor: default;
}

>>> .sort,
>>> label {
  font-family: Courier;
  color: #444;
  padding: 5px;
  margin: 5px;
}

>>> label {
  vertical-align: text-bottom;
}

>>> .filter {
  border-radius: 3px;
  background-color: #eee;
  padding: 5px;
  margin: 5px;
  color: #444;
  text-align: left;
  display: inline-block;
  cursor: default;
}
</style>
